import { Box, Input } from "@chakra-ui/react"
import { Button, Text } from "@/components/ui"

interface Props {
  email: string;
  setEmail: (email: string) => void;
  handleLogin: () => Promise<void>;
  isLoading: boolean;
  /**
   * Message to show when sign-in failed for a reason the client can act on — most often
   * "we can't text a code to the number on file for you".
   *
   * Before this existed the catch in LoginComponent logged to the console and rendered
   * nothing, so a client whose number we cannot text saw the spinner stop and nothing else.
   * Every client with an international phone number was in that state.
   */
  errorMessage?: string | null;
}

export const SignInComponent = ({ email, setEmail, handleLogin, isLoading, errorMessage }: Props) => {
  return (
    <Box w={{ base: "92%", md: "55%" }} zIndex={1} bg="white" p={{ base: 6, md: 10 }} borderRadius={10} boxShadow="lg" minW="300px">
      <Text fontSize="3xl" fontWeight="semibold" mb={6}>
        Log into your account
      </Text>
      <Box pl={5} pr={5}>
        <Text mb={2}>Email address</Text>
        <Input
          fontFamily="body"
          placeholder="Enter your email"
          mb={errorMessage ? 4 : 10}
          borderColor="brand.300"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleLogin()
            }
          }}
        />
        {errorMessage && (
          <Box
            role="alert"
            mb={6}
            p={3}
            borderRadius={6}
            bg="red.50"
            borderWidth="1px"
            borderColor="red.200"
          >
            <Text fontSize="sm" color="red.700">
              {errorMessage}
            </Text>
          </Box>
        )}
        <Button variant="solid" w="full" onClick={handleLogin} loading={isLoading}>
          Sign in
        </Button>
      </Box>
    </Box>
  )
}
